module.exports = __webpack_public_path__ + "img/精致美型--额头gif.56a471ac.gif";